import { render, staticRenderFns } from "./PaxPays.vue?vue&type=template&id=f80241cc&"
import script from "./PaxPays.vue?vue&type=script&lang=js&"
export * from "./PaxPays.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports